import { render, staticRenderFns } from "./SalepointTypeForm.vue?vue&type=template&id=525e46d0"
import script from "./SalepointTypeForm.vue?vue&type=script&lang=js"
export * from "./SalepointTypeForm.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports